export default "__VITE_ASSET__81676409__"